export default __webpack_public_path__ + "static/media/notifications-24px.18e8378a.svg";